<template>
  <!-- <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"> -->
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="width"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="问题类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            show-search
            placeholder="请选择问题类型"
            v-decorator="[
              'typeId',
              { rules: [{ required: true, message: '请选择问题类型' }] },
            ]"
          >
            <a-select-option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.id"
            >
              {{ item.type }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="关键词"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'keyWord',
              { rules: [{ required: true, message: '请输入关键词' }] },
            ]"
            placeholder="请输入关键词"
            :disabled="!!this.model.id"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="跳转链接"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入跳转链接"
            v-decorator="[
              'jumpUrl',
              { rules: [{ required: true, message: '请输入跳转链接' }] },
            ]"
            :disabled="!!this.model.id"
          ></a-input>
        </a-form-item>

        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['sortIndex']" :min="0" />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
  <!-- </j-modal> -->
</template>

<script>
// import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import { postTag } from '../../../../api/manage';

export default {
  name: 'CommonProblemModal',
  components: {
    JDate,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/ct/problem/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/ct/problem/edit',
      },
      typeList: [],
    };
  },
  created() {},
  methods: {
    add(typeList) {
      this.typeList = typeList;
      this.form.resetFields();
      this.model = Object.assign({});
      console.log('addmodel', this.model);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'typeId', 'keyWord', 'jumpUrl', 'sortIndex')
        );
      });
    },
    edit(records, typeList) {
      this.typeList = typeList;
      this.form.resetFields();
      let record = { ...records };
      this.model = Object.assign({}, record);
      console.log('editmodel', this.model);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'typeId', 'keyWord', 'jumpUrl', 'sortIndex')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'typeId', 'keyWord', 'jumpUrl', 'sortIndex')
      );
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
